import {Record} from 'immutable';

const Token = Record({
    expires: '',
    token: '',
});

const fromAPI = data => {
    return new Token({
        ...data,
    });
};

export default {
    record: Token,
    default: new Token(),
    fromAPI,
};
